import React from 'react';
import SellingPoint from './selling-point';
import Billboard from './billboard';
import Rts from './rts';
import './index.less';

/**
 * globalDataKeys: [
              'product.labels',
              'i18n',
              'extend.recommendBillboard',
              'trade.hasLogistics'
              'trade.leadTimeInfo'
              'buyer.coreCountry'
              "product.productIsMarketGoods",
            ],
 */

export default function ProductCertification(props: TitleType.Root) {
  const {
    labels = [],
    hasLogistics,
    recommendBillboard,
    leadTimeInfo,
    productIsMarketGoods,
    coreCountry,
  } = props;

  return (
    <>
      {recommendBillboard ? (
        <Billboard recommendBillboard={recommendBillboard} />
      ) : (
        <>
          {/* 非核心六国且有rts标，则出rts标志 */}
          {productIsMarketGoods && !coreCountry && (
            <Rts hasLogistics={hasLogistics} leadTimeInfo={leadTimeInfo} />
          )}
          {/* 待服务端下掉labels后可删除 */}
          <SellingPoint labels={labels} />
        </>
      )}
    </>
  );
}
